import calcItemTotalEnc from './calcItemTotalEnc'
//-------------------------
// calc container contents
//-------------------------
export default function calcContainerContents({ container_id, character_items }) {
  console.log('---------------------------------')
  console.log('IN calcContainerContents')
  console.log('container id = ', container_id)
  console.log('character_items = ', character_items)

  if (!container_id || !character_items) {
    return { tot_enc: 0, contents_enc: 0, contents_count_direct: 0, contents_count_total: 0 }
  }
  //--------------------
  // get this container
  //--------------------
  const container = character_items.find((ci) => ci.id === container_id)
  if (!container) {
    console.error('container not found in character items for id = ', container_id)
    return { tot_enc: 0, contents_enc: 0, contents_count_direct: 0, contents_count_total: 0 }
  }
  console.log('processing container name = ', container.name)
  //-------------------------------
  // specify the container own enc
  //-------------------------------
  const containerEncRaw = container.enc ?? 0
  const container_enc =
    typeof containerEncRaw === 'string' ? parseFloat(containerEncRaw) : containerEncRaw
  //------------------------------
  // find items in this container
  //------------------------------
  const contents = character_items.filter((ci) => ci.container === container_id)
  //--------------------------------------------------------
  // loop contents once to get both count and total enc
  //--------------------------------------------------------
  const contentsAgg = contents.reduce(
    (acc, item) => {
      //---------------------------------
      // accumulate tally-based quantity
      //---------------------------------
      const rawQty = item.tally_qty ?? 0
      const qty = typeof rawQty === 'string' ? parseInt(rawQty, 10) : rawQty
      acc.contents_count_direct += Number.isFinite(qty) ? qty : 0

      //----------------------------------------------------
      // calc total enc contribution for this item
      // - plain items: use own ENC x tally (via calcItemTotalEnc)
      // - child containers: include their own ENC + their contents ENC
      //----------------------------------------------------
      let item_enc = 0

      // treat as container only if it is marked as storage
      // (storage=true means this item can hold other items)
      const isContainerItem = item.storage === true

      if (isContainerItem) {
        // prefer an existing tot_enc if present
        const totRaw = item.tot_enc
        const totNum =
          typeof totRaw === 'string'
            ? parseFloat(totRaw)
            : typeof totRaw === 'number'
              ? totRaw
              : NaN

        if (!Number.isNaN(totNum)) {
          item_enc = totNum
        } else {
          // fallback: base ENC + contents ENC
          const baseEncRaw = item.enc ?? 0
          const baseEnc =
            typeof baseEncRaw === 'string'
              ? parseFloat(baseEncRaw)
              : typeof baseEncRaw === 'number'
                ? baseEncRaw
                : 0
          const childEncRaw = item.contents_enc ?? 0
          const childEnc =
            typeof childEncRaw === 'string'
              ? parseFloat(childEncRaw)
              : typeof childEncRaw === 'number'
                ? childEncRaw
                : 0
          item_enc = baseEnc + childEnc
        }
      } else {
        // non-container items: use standard per-item ENC calculation (handles tally_qty)
        item_enc = calcItemTotalEnc({ character_item: item })
      }

      acc.contents_enc += item_enc

      return acc
    },
    { contents_count_direct: 0, contents_enc: 0 },
  )

  const contents_count_direct = contentsAgg.contents_count_direct
  let contents_enc = contentsAgg.contents_enc

  // normalise to 2 decimal places to avoid FP artefacts
  contents_enc = Math.round((contents_enc + Number.EPSILON) * 100) / 100
  //----------------
  // calc total enc
  //----------------
  let tot_enc = container_enc + contents_enc
  tot_enc = Math.round((tot_enc + Number.EPSILON) * 100) / 100

  //-----------------------------------
  // calc total nested contents count
  // (direct children + all descendants)
  //-----------------------------------
  const calcTotalContentsCount = ({ rootId, items }) => {
    if (!rootId || !Array.isArray(items)) {
      return 0
    }

    let total = 0
    const stack = [rootId]

    while (stack.length > 0) {
      const currentId = stack.pop()
      const children = items.filter((it) => it && it.container === currentId)

      for (const child of children) {
        const rawQty = child && child.tally_qty != null ? child.tally_qty : 0
        const qty = typeof rawQty === 'string' ? parseInt(rawQty, 10) : rawQty

        if (Number.isFinite(qty) && qty > 0) {
          total += qty
        }

        // if the child is itself a storage item, traverse its contents
        if (child && child.storage === true && child.id) {
          stack.push(child.id)
        }
      }
    }

    return total
  }

  const contents_count_total = calcTotalContentsCount({
    rootId: container_id,
    items: character_items,
  })

  console.log('container_enc = ', container_enc)
  console.log('contents_enc = ', contents_enc)
  console.log('total_enc = ', tot_enc)
  console.log('contents_count_direct = ', contents_count_direct)

  console.log('contents_count_total = ', contents_count_total)

  return { tot_enc, contents_enc, contents_count_direct, contents_count_total }
}
